// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2FwFB","icon":"SortAdornment_icon__2JAQk","up":"SortAdornment_up__30IBS","down":"SortAdornment_down__3s42L","active":"SortAdornment_active__vjcg_"};